








































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component
export default class DeleteCommentField extends Vue {
  @Prop({type: Object, default: {}}) private comment!: any;

  private loading: boolean = false;
  private dialog: boolean = false;

  @Action('admin/comments/del') private storeDeleteComment!: (comment: any) => Promise<boolean>;
  @Action('admin/posts/readOne') private readPost!: ({id}) => Promise<boolean>;

  private deleteComment() {
    this.loading = true;
    this.dialog = false;
    this.storeDeleteComment(this.comment)
      .then((success) => {
        if (!success) {
          throw new Error('Error while creating comment');
        }
        return this.readPost({id: this.comment.postId});
      })
      .then((post) => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
